/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * FolderAddIcon
 */
export default class FolderAddIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M4.222 3h2.516c.826 0 1.618.309 2.216.86l.145.144.584.613c.198.208.47.34.764.375l.148.008h9.183c1.71 0 3.122 1.304 3.217 2.964l.005.179V10.5a1 1 0 01-1.993.117L21 10.5V8.143c0-.584-.474-1.078-1.096-1.137L19.778 7h-9.183a3.267 3.267 0 01-2.215-.86l-.145-.144-.584-.613a1.252 1.252 0 00-.764-.375L6.738 5H4.222c-.64 0-1.154.457-1.216 1.027L3 6.143v10.714c0 .584.474 1.078 1.096 1.137l.126.006H13.5a1 1 0 01.117 1.993L13.5 20H4.222c-1.71 0-3.122-1.304-3.217-2.964L1 16.857V6.143c0-1.684 1.352-3.046 3.04-3.138L4.222 3h2.516zM18.5 11a1 1 0 011 1v2.5H22a1 1 0 01.117 1.993L22 16.5h-2.5V19a1 1 0 01-.883.993L18.5 20a1 1 0 01-1-1v-2.5H15a1 1 0 01-.117-1.993L15 14.5h2.5V12a1 1 0 01.883-.993z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

